import React, { useState } from 'react';
import '../styles/contact.css';
import { Container, Row, Col } from 'reactstrap';
import { BASE_URL } from '../utils/config';
import CommonSection from '../shared/CommonSection';


const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${BASE_URL}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('Failed to send message. Please try again later.');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('An error occurred. Please try again later.');
    }
  };

  return (


    <section className="contact">
              <CommonSection title="Contact Us" />

      <Container>
        <Row>
          {/* Contact Form Section */}
          <Col lg="6" md="12">
            <div className="contact__content">
              <h1 className="contact__title">Get in Touch</h1>
              <form className="contact__form" onSubmit={handleSubmit}>
                <div className="form__group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div className="form__group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your Email"
                    required
                  />
                </div>
                <div className="form__group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    placeholder="Your Message"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">Send Message</button>
                {status && <p className="form-status">{status}</p>}
              </form>
            </div>
          </Col>

          {/* Payment Details Section */}
          <Col lg="6" md="12">
            <div className="payment">
              <h2 className="payment__title">Payment Details</h2>
              <Row>
                {/* Bank Details 1 */}
                <Col lg="6" md="6" sm="12">
                  <div className="payment__card">
                    <h3 className="payment__card-title">Bank Transfer (USD)</h3>
                    <p>Account Name: Coast Camping Tours and Safaris Limited</p>
                    <p>Account Number: 0900466702</p>
                    <p>Bank: Gulf African Bank</p>
                    <p>Branch: Nkrumah Road Branch</p>
                    <p>Swift Code: GAFRKENA</p>
                  </div>
                </Col>

                {/* Bank Details 2 */}
                <Col lg="6" md="6" sm="12">
                  <div className="payment__card">
                    <h3 className="payment__card-title">Bank Transfer (KES)</h3>
                    <p>Account Name: Coast Camping Tours and Safaris Limited</p>
                    <p>Account Number: <span>0900466701</span></p>
                    <p>Bank: Gulf African Bank</p>
                    <p>Branch: Nkrumah Road Branch</p>
                    <p>Swift Code: GAFRKENA</p>
                  </div>
                </Col>
              </Row>

              {/* Mobile Payment Details */}
              <Row>
                <Col lg="12">
                  <div className="payment__card">
                    <h3 className="payment__card-title">Mobile Payment</h3>
                    <p>Service: M-Pesa</p>
                    <p>Paybill: 4092131</p>
                    <p>Account: Name as per the ID</p>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    
  );
};

export default Contact;
